import {
  Component,
  OnInit,
  AfterViewInit,
  OnChanges,
  Input,
  SimpleChanges,
  OnDestroy
} from "@angular/core";
import { WidgetOverallStatusTrendService } from "./service/widget-overall-status-trend.service";
import * as Highcharts from "highcharts";
import addMore from "highcharts/highcharts-more";
import { TranslateService } from "@ngx-translate/core";
import { LocalStorageService } from "../../../services/local-storage.service";
import { BroadcasterService } from "../../../../core/services/broadcaster.service";
import * as HSET from "./settings";
import { CommonService } from './../../../services/common.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
addMore(Highcharts);
@Component({
  selector: "widget-overall-status-trend",
  templateUrl: "./widget-overall-status-trend.component.html",
  styleUrls: ["./widget-overall-status-trend.component.scss"],
  providers: [WidgetOverallStatusTrendService]
})
export class WidgetOverallStatusTrendComponent implements OnInit, OnChanges, OnDestroy {
  @Input() FILTERS;
  @Input() OPTIONS;
  widgetId = 20;

  highcharts: typeof Highcharts = Highcharts;
  loadingChart = true;
  chartOptions: HSET.chartData = HSET.chartData;
  errorMessage = "";
  mockChart = null;
  private unsubscribe: Subject<void> = new Subject();

  constructor(
    private translateService: TranslateService,
    private dataService: WidgetOverallStatusTrendService,
    private broadcaster: BroadcasterService,
    private localStorageService: LocalStorageService,
    private commonService: CommonService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (
      JSON.stringify(changes.FILTERS.currentValue) !==
        JSON.stringify(changes.FILTERS.previousValue) &&
      !changes.FILTERS.firstChange
    ) {
      this.getSLAtrendData();
    }
  }

  ngOnInit() {
    this.translateService
      .get("WAREHOUSE.WAREHOUSE_SLA_TREND")
      .subscribe(text => {
        this.OPTIONS.title = this.OPTIONS.title || text;
      });
    this.broadcaster.listen("PAGE_WIDGET_DATA").pipe(takeUntil(this.unsubscribe)).subscribe(() => {
      //this.setWidgetData();
    });

    this.getSLAtrendData();
  }
  setWidgetData() {
    const pageData = this.localStorageService.getItem("PAGE_WIDGET_DATA");
    if (pageData) {
      pageData.forEach(element => {
        if (element.widget_id === this.widgetId) {
          this.setTarget(element.target);
        }
      });
    }
  }

  setTarget(t) {
    if (this.chartOptions) {
      this.chartOptions.series[2].data = [];
      for (let i = 0; i < this.chartOptions.series[0].data.length; i++) {
        this.chartOptions.series[2].data.push(t);
      }
    }
  }

  getSLAtrendData() {
    const params = {};
    this.errorMessage = "";
    this.mockChart = null;
    this.loadingChart = true;
    this.dataService.getSLAtrendData(this.OPTIONS.api, this.FILTERS).pipe(takeUntil(this.unsubscribe)).subscribe(
      chart => {
        if (chart.success) {
          this.loadingChart = false;
          this.chartOptions = this.dataService.createChart(chart, this.OPTIONS);
        } else {
          this.loadingChart = true;
          this.errorMessage = "ERROR_MSG.NO_DATA";
          this.mockChart = HSET.chartData;
        }
      },
      error => {
        this.loadingChart = true;

        this.errorMessage = "ERROR_MSG.SYSTEM_ERROR";
        this.mockChart = HSET.chartData;
      }
    );
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
